import { createFileRoute } from '@tanstack/react-router';

import { EchecsEnvoi } from '@/features/documentation/echecs-envoi';

export const Route = createFileRoute('/_app/docs/delivery-failures')({
  component: EchecsEnvoi,
});
